// extracted by mini-css-extract-plugin
export default {"guestsCount":"cNyVc","skeleton-progress":"VBQL5"};